import Paper from '@mui/material/Paper'
import classNames from 'classnames'
import { ForwardedRef, ReactNode, forwardRef } from 'react'

// Side padding is required on heading elements to make them appear in the appropriate position.
// We need side padding removal on the whole card to make children expand themselves to the full
// width of the container.

type Props = {
    title?: string
    subTitle?: string
    children?: ReactNode
    className?: string
    withoutSidePadding?: boolean
    refKey?: string
}

const DefaultCard = forwardRef(
    (
        {
            title,
            subTitle,
            children,
            className,
            withoutSidePadding,
            refKey
        }: Props,
        ref?: ForwardedRef<any>
    ) => {
        return (
            <Paper
                className={classNames(
                    'defaultCard',
                    { withoutSidePadding },
                    className
                )}
                id={refKey}
                ref={ref}
            >
                <div className="cardAnchor">
                    <div className="cardAnchor__element" />
                </div>
                {title && (
                    <h2
                        className={classNames('defaultCard__title', {
                            withSidePadding: withoutSidePadding,
                            withBottomMargin: !subTitle
                        })}
                    >
                        {title}
                    </h2>
                )}
                {subTitle && (
                    <h3
                        className={classNames('defaultCard__subtitle', {
                            withSidePadding: withoutSidePadding
                        })}
                    >
                        {subTitle}
                    </h3>
                )}

                {children}
            </Paper>
        )
    }
)

DefaultCard.displayName = 'DefaultCard'

export default DefaultCard
